import { withRouter } from "react-router";
import Background from "../components/Background";
import Button from "../components/Button";
import OrdersTable from "../components/OrdersTable";
import NavTopBar from "../components/NavTopBar";
import OverTableButtons from "../components/OverTableButtons";
import Footer from "../components/Footer";
import PlainContainer from "../components/PlainContainer";

const RegisterOrdersView = ({ history }) => {
  return (
    <>
      <NavTopBar />
      <Background height="45vh" />

      <PlainContainer
        widthInVw={95}
        heightInVh={'auto'}
        customStyles={{
          top: "19vh",
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          paddingBottom: "0px",
        }}
      >

        <OrdersTable />
      </PlainContainer>

      <Footer />
    </>
  );
};

export default withRouter(RegisterOrdersView);
